// removed by extract-text-webpack-plugin
module.exports = {"box":"_9hwGjwaGJ3kAzPCVhX4Dk","header":"MeyEYcdjFShtQYgUrJPJf","webcams":"_3i55AN8NLhaEIZFCSyhEK-","infographics":"_3T-wUsXZfJXD0NPIxyu0zi","indicators":"_2ouMlPSz6pUPhc5Rm-XcaT","active":"_3iI2-g9D1OqUmfF1POut3J"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RightNowBox/RightNowBox.module.scss
// module id = 805
// module chunks = 0